(() => {
  const AI_KEY = 'mj_ai_engraving';
  function readState() {
    try { return JSON.parse(sessionStorage.getItem(AI_KEY) || '{}') || {}; } catch { return {}; }
  }
  function saveState(state) {
    try { sessionStorage.setItem(AI_KEY, JSON.stringify(state)); } catch { /* Browsing can continue when storage is unavailable. */ }
  }
  function initialize(root) {
    if (root.dataset.designReady) return;
    root.dataset.designReady = 'true';
    const form = root.querySelector('[data-design-form]');
    const prompt = root.querySelector('[data-design-prompt]');
    const button = root.querySelector('[data-design-generate]');
    const label = root.querySelector('[data-design-button-label]');
    const spinner = root.querySelector('[data-design-spinner]');
    const status = root.querySelector('[data-design-status]');
    const overlay = root.querySelector('[data-design-overlay]');
    const result = root.querySelector('[data-design-result]');
    const caption = root.querySelector('[data-design-caption]');
    const styles = [...root.querySelectorAll('[data-design-style]')];
    const idleLabel = label.textContent;
    let theme = 'classic';
    let generated = false;
    let busy = false;
    function setStatus(message, error = false) {
      status.textContent = message;
      status.dataset.error = String(error);
    }
    function selectStyle(value) {
      theme = styles.some(style => style.dataset.designStyle === value) ? value : 'classic';
      styles.forEach(style => {
        const selected = style.dataset.designStyle === theme;
        style.setAttribute('aria-pressed', String(selected));
        if (selected && !generated) overlay.src = style.querySelector('img').src;
      });
    }
    function showResult(url) {
      generated = true;
      overlay.src = url;
      overlay.alt = 'Your personalized engraving';
      result.hidden = false;
      caption.textContent = 'Your design. Your complimentary walnut gift box.';
    }
    const saved = readState();
    if (saved.url) {
      showResult(saved.url);
      prompt.value = saved.subject || '';
    }
    selectStyle(saved.theme);
    styles.forEach(style => style.addEventListener('click', () => {
      if (!busy) selectStyle(style.dataset.designStyle);
    }));
    root.querySelector('[data-design-again]').addEventListener('click', () => {
      prompt.focus();
      prompt.select();
    });
    root.querySelector('.vg-design-claim').addEventListener('click', () => {
      const design = readState();
      if (!design.url) return;
      try {
        const box = JSON.parse(sessionStorage.getItem('mj_box_customization') || '{}') || {};
        box.style = 'Custom Design';
        box.skipped = false;
        box.values = { ...box.values, 'Design Description': design.subject || '' };
        sessionStorage.setItem('mj_box_customization', JSON.stringify(box));
      } catch { /* The saved artwork remains available in the product designer. */ }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const subject = prompt.value.trim();
      if (!subject) {
        setStatus('Add an idea for your engraving.', true);
        prompt.focus();
        return;
      }
      const state = readState();
      if ((state.tries || 0) >= 20) {
        setStatus('You have reached the design limit for this visit.', true);
        return;
      }
      busy = true;
      button.disabled = true;
      styles.forEach(style => { style.disabled = true; });
      spinner.hidden = false;
      form.setAttribute('aria-busy', 'true');
      label.textContent = 'Creating your design...';
      setStatus('');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 90000);
      try {
        const response = await fetch(root.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ theme, subject }), signal: controller.signal
        });
        const data = await response.json();
        const next = readState();
        next.tries = (next.tries || 0) + 1;
        next.lastGen = Date.now();
        if (!response.ok || !data.url) {
          saveState(next);
          throw new Error('generation');
        }
        next.url = data.url;
        next.subject = subject;
        next.theme = theme;
        next.history = Array.isArray(next.history) ? next.history : [];
        next.history.push({ url: data.url, subject });
        saveState(next);
        showResult(data.url);
        setStatus('Your design is ready.');
      } catch (error) {
        setStatus(error.name === 'AbortError' ? 'This is taking longer than expected. Please try again.' : 'The design could not be created. Please try again.', true);
      } finally {
        clearTimeout(timeout);
        busy = false;
        button.disabled = false;
        styles.forEach(style => { style.disabled = false; });
        spinner.hidden = true;
        form.setAttribute('aria-busy', 'false');
        label.textContent = idleLabel;
      }
    });
  }
  function mount(scope) { scope.querySelectorAll('[data-vg-design]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
